export default __webpack_public_path__ + "static/media/39k.666057c7.md";